"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTheme = exports.switchActivePanel = exports.changeWidgetPanelWidth = exports.toggleWidgetPanel = exports.deactivateCollaborator = exports.activeCollaborator = exports.updateResourceName = exports.resetResource = exports.updateResource = exports.resourceErrorCode = exports.roomInfoSync = exports.changeResourceSyncingStatus = exports.setResourceConnect = exports.updateRevision = exports.applyJOTOperations = void 0;
const action_constants_1 = require("../../../../shared/store/action_constants");
const types_1 = require("../../../../../types");
const dashboard_1 = require("./dashboard");
const datasheet_1 = require("./datasheet");
const form_1 = require("./form");
const widget_1 = require("./widget");
const mirror_1 = require("../../../../../modules/database/store/actions/resource/mirror");
__exportStar(require("./dashboard"), exports);
__exportStar(require("./datasheet"), exports);
__exportStar(require("./form"), exports);
__exportStar(require("./widget"), exports);
__exportStar(require("./mirror"), exports);
const applyJOTOperations = (operations, resourceType, resourceId) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return {
                payload: { operations },
                type: action_constants_1.DASHBOARD_JOT_ACTION,
                dashboardId: resourceId,
            };
        }
        case types_1.ResourceType.Widget: {
            return {
                payload: { operations },
                type: action_constants_1.WIDGET_JOT_ACTION,
                widgetId: resourceId,
            };
        }
        case types_1.ResourceType.Form: {
            return {
                payload: { operations },
                type: action_constants_1.FORM_JOT_ACTION,
                formId: resourceId,
            };
        }
        case types_1.ResourceType.Mirror: {
            return {
                payload: { operations },
                type: action_constants_1.MIRROR_JOT_ACTION,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                payload: { operations },
                datasheetId: resourceId,
                type: action_constants_1.DATASHEET_JOT_ACTION,
            };
        }
    }
};
exports.applyJOTOperations = applyJOTOperations;
const updateRevision = (revision, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return {
                payload: revision,
                type: action_constants_1.DASHBOARD_UPDATE_REVISION,
                dashboardId: resourceId,
            };
        }
        case types_1.ResourceType.Widget: {
            return {
                payload: revision,
                type: action_constants_1.WIDGET_UPDATE_REVISION,
                widgetId: resourceId,
            };
        }
        case types_1.ResourceType.Form: {
            return {
                payload: revision,
                type: action_constants_1.FORM_UPDATE_REVISION,
                formId: resourceId,
            };
        }
        case types_1.ResourceType.Mirror: {
            return {
                payload: revision,
                type: action_constants_1.MIRROR_UPDATE_REVISION,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                payload: revision,
                type: action_constants_1.DATASHEET_UPDATE_REVISION,
                datasheetId: resourceId,
            };
        }
    }
};
exports.updateRevision = updateRevision;
const setResourceConnect = (resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return {
                type: action_constants_1.DASHBOARD_CONNECTED,
                dashboardId: resourceId,
            };
        }
        case types_1.ResourceType.Form: {
            return {
                type: action_constants_1.FORM_CONNECTED,
                formId: resourceId,
            };
        }
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.MIRROR_CONNECTED,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                type: action_constants_1.DATASHEET_CONNECTED,
                datasheetId: resourceId,
            };
        }
    }
};
exports.setResourceConnect = setResourceConnect;
const changeResourceSyncingStatus = (resourceId, resourceType, status) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return {
                type: action_constants_1.SET_DASHBOARD_SYNCING,
                payload: status,
                dashboardId: resourceId,
            };
        }
        case types_1.ResourceType.Form: {
            return {
                type: action_constants_1.SET_FORM_SYNCING,
                payload: status,
                formId: resourceId,
            };
        }
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.SET_MIRROR_SYNCING,
                payload: status,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                type: action_constants_1.SET_DATASHEET_SYNCING,
                payload: status,
                datasheetId: resourceId,
            };
        }
    }
};
exports.changeResourceSyncingStatus = changeResourceSyncingStatus;
const roomInfoSync = (resourceId, resourceType, payload) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return {
                type: action_constants_1.DASHBOARD_ROOM_INFO_SYNC,
                payload,
                dashboardId: resourceId,
            };
        }
        case types_1.ResourceType.Form: {
            return {
                type: action_constants_1.FORM_ROOM_INFO_SYNC,
                payload,
                formId: resourceId,
            };
        }
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.MIRROR_ROOM_INFO_SYNC,
                payload,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                type: action_constants_1.DATASHEET_ROOM_INFO_SYNC,
                payload,
                datasheetId: resourceId,
            };
        }
    }
};
exports.roomInfoSync = roomInfoSync;
const resourceErrorCode = (code, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return (0, dashboard_1.setDashboardErrorCode)(resourceId, code);
        }
        case types_1.ResourceType.Form: {
            return (0, form_1.formErrorCode)(resourceId, code);
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return (0, datasheet_1.datasheetErrorCode)(resourceId, code);
        }
    }
};
exports.resourceErrorCode = resourceErrorCode;
const updateResource = (data, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return {
                type: action_constants_1.UPDATE_DASHBOARD,
                payload: data,
                dashboardId: resourceId,
            };
        }
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.UPDATE_MIRROR,
                payload: data,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return (0, datasheet_1.updateDatasheet)(resourceId, data);
        }
    }
};
exports.updateResource = updateResource;
const resetResource = (resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Widget: {
            return (0, widget_1.resetWidget)([resourceId]);
        }
        case types_1.ResourceType.Form: {
            return (0, form_1.resetForm)(resourceId);
        }
        case types_1.ResourceType.Dashboard: {
            return (0, dashboard_1.resetDashboard)(resourceId);
        }
        case types_1.ResourceType.Mirror: {
            return (0, mirror_1.resetMirror)(resourceId);
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return (0, datasheet_1.resetDatasheet)(resourceId);
        }
    }
};
exports.resetResource = resetResource;
const updateResourceName = (newName, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return (0, dashboard_1.updateDashboardName)(newName, resourceId);
        }
        case types_1.ResourceType.Datasheet:
            return (0, datasheet_1.updateDatasheetName)(resourceId, newName);
        case types_1.ResourceType.Mirror:
            return (0, mirror_1.updateMirrorName)(newName, resourceId);
        default:
            return;
    }
};
exports.updateResourceName = updateResourceName;
const activeCollaborator = (payload, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return (0, dashboard_1.activeDashboardCollaborator)(payload, resourceId);
        }
        case types_1.ResourceType.Mirror: {
            return (0, mirror_1.activeMirrorCollaborator)(payload, resourceId);
        }
        case types_1.ResourceType.Form: {
            return (0, form_1.activeFormCollaborator)(payload, resourceId);
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return (0, datasheet_1.activeDatasheetCollaborator)(payload, resourceId);
        }
    }
};
exports.activeCollaborator = activeCollaborator;
const deactivateCollaborator = (payload, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Dashboard: {
            return (0, dashboard_1.deactivateDashboardCollaborator)(payload, resourceId);
        }
        case types_1.ResourceType.Mirror: {
            return (0, mirror_1.deactivateMirrorCollaborator)(payload, resourceId);
        }
        case types_1.ResourceType.Form: {
            return (0, form_1.deactivateFormCollaborator)(payload, resourceId);
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return (0, datasheet_1.deactivateDatasheetCollaborator)(payload, resourceId);
        }
    }
};
exports.deactivateCollaborator = deactivateCollaborator;
const toggleWidgetPanel = (resourceId, resourceType, status) => {
    switch (resourceType) {
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.TOGGLE_WIDGET_PANEL,
                payload: status,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                type: action_constants_1.TOGGLE_WIDGET_PANEL,
                payload: status,
                datasheetId: resourceId,
            };
        }
    }
};
exports.toggleWidgetPanel = toggleWidgetPanel;
const changeWidgetPanelWidth = (width, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.CHANGE_WIDGET_PANEL_WIDTH,
                payload: width,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                type: action_constants_1.CHANGE_WIDGET_PANEL_WIDTH,
                payload: width,
                datasheetId: resourceId,
            };
        }
    }
};
exports.changeWidgetPanelWidth = changeWidgetPanelWidth;
const switchActivePanel = (panelId, resourceId, resourceType) => {
    switch (resourceType) {
        case types_1.ResourceType.Mirror: {
            return {
                type: action_constants_1.SWITCH_ACTIVE_PANEL,
                payload: panelId,
                mirrorId: resourceId,
            };
        }
        case types_1.ResourceType.Datasheet:
        default: {
            return {
                type: action_constants_1.SWITCH_ACTIVE_PANEL,
                payload: panelId,
                datasheetId: resourceId,
            };
        }
    }
};
exports.switchActivePanel = switchActivePanel;
const setTheme = (theme) => {
    return {
        type: action_constants_1.SET_THEME,
        payload: theme,
    };
};
exports.setTheme = setTheme;
//# sourceMappingURL=index.js.map